import type * as Icons from "@mui/icons-material";

export const DRAWER_WIDTH = 240;

export interface NavItem {
  labelKey: string;
  path: string;
  icon: keyof typeof Icons;
}

export const NAV_ITEMS: NavItem[] = [
  { labelKey: "nav.home", path: "/dashboard", icon: "Dashboard" },
  { labelKey: "nav.clubs", path: "/clubs", icon: "Groups" },
  { labelKey: "nav.members", path: "/members", icon: "People" },
  { labelKey: "nav.memberships", path: "/memberships", icon: "CardMembership" },
  { labelKey: "nav.attendances", path: "/attendances", icon: "EventAvailable" },
];

export const SETTINGS_NAV: NavItem = {
  labelKey: "nav.settings",
  path: "/settings",
  icon: "Settings",
};
